/* RESPONSIBLE TEAM: team-knowledge-foundations */
import Service, { inject as service } from '@ember/service';
import type ModalService from 'embercom/services/modal-service';

export default class AddWebsiteModalService extends Service {
  @service declare modalService: ModalService;
  @service declare appService: $TSFixMe;

  openAddWebsiteSheet() {
    this.modalService.openModal('react/knowledge-hub/add-content/add-website/add-website-sheet', {
      open: true,
      appId: this.appService.app.id,
      adminId: this.appService.app.currentAdmin.id.toString(),
      onClose: () => this.modalService.closeModal(),
      onSubmit: () => this.modalService.closeModal(),
    });
  }
}

declare module '@ember/service' {
  interface Registry {
    'add-website-modal-service': AddWebsiteModalService;
  }
}
